var render, staticRenderFns
import script from "./base-select-filter.vue?vue&type=script&lang=js"
export * from "./base-select-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32356f34')) {
      api.createRecord('32356f34', component.options)
    } else {
      api.reload('32356f34', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/js/components/filter/v2/filters/base-select-filter.vue"
export default component.exports